// Facebook Pixel Event Tracking Utilities

export const FB_PIXEL_ID = '865138525939370';

// Track Lead event for all CTA buttons
export const trackLead = (buttonName = 'Unknown') => {
  if (window.fbq) {
    window.fbq('track', 'Lead', {
      content_name: buttonName,
      source: 'website_cta'
    });
    console.log('✅ FB Pixel - Lead event tracked:', buttonName);
  } else {
    console.warn('⚠️ FB Pixel not loaded');
  }
};

// Track specific button clicks
export const trackButtonClick = (buttonName) => {
  if (window.fbq) {
    window.fbq('trackCustom', 'ButtonClick', {
      button_name: buttonName
    });
    console.log('✅ FB Pixel - Button click tracked:', buttonName);
  }
};

// Track calculator usage
export const trackCalculatorUse = (investmentAmount, strategy) => {
  if (window.fbq) {
    window.fbq('trackCustom', 'CalculatorUsed', {
      investment: investmentAmount,
      strategy: strategy
    });
    console.log('✅ FB Pixel - Calculator used');
  }
};

// Track strategy view
export const trackStrategyView = (strategyName) => {
  if (window.fbq) {
    window.fbq('trackCustom', 'StrategyViewed', {
      strategy_name: strategyName
    });
    console.log('✅ FB Pixel - Strategy viewed:', strategyName);
  }
};
